import { Injectable  } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: "root"
  })


export class PasswordService {

    urlSeguimentos = `${environment.API}seguimentos`;
    urlPassword = `${environment.API}users`;
    headers = new HttpHeaders({'authorization':sessionStorage.getItem("token")});
    
    constructor(private http: HttpClient) { }

    alteraSenha(codigo,password,passwordatual): Observable<any> {
        return this.http.put(this.urlPassword, {codigo,password,passwordatual },{headers: this.headers});
      }

}